import { useTranslation } from "react-i18next";
import { MapPin, Megaphone, Users, Camera, TrendingUp, HeartHandshake, Sparkles, LineChart } from "lucide-react";
import { useSeo } from "../lib/useSeo";
import { htmlLangOf } from "../i18n";
import { PartnerForm } from "../components/PartnerForm";

const ICONS = [MapPin, Megaphone, Users, Camera, TrendingUp, HeartHandshake, Sparkles, LineChart];
const PARTNER_IMG = "https://images.pexels.com/photos/3738387/pexels-photo-3738387.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function PublicPartners() {
  const { t, i18n } = useTranslation();

  useSeo({
    title: `${t("pub.ctaPartnerVytali")} · VytaliDays`,
    description: t("pub.partnerText"),
    path: "/partners",
    lang: htmlLangOf(i18n.language),
  });

  return (
    <div data-testid="public-partners-page">
      <section className="vy-hero px-4 py-14 sm:px-6 sm:py-20">
        <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-2">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-accent">{t("pub.eyebrow")}</p>
            <h1 className="mt-4 font-display text-4xl font-extrabold leading-tight text-white sm:text-5xl">
              {t("pub.partnerTitle")}
            </h1>
            <p className="mt-5 text-base text-white/75">{t("pub.partnerText")}</p>
            <p className="mt-6 inline-block rounded-full bg-white/10 px-4 py-2 text-sm font-bold text-white">
              {t("pub.retention")}
            </p>
          </div>
          <img src={PARTNER_IMG} alt={t("pub.partnerTitle")}
            className="aspect-[4/3] w-full rounded-3xl object-cover shadow-2xl" />
        </div>
      </section>

      <section className="px-4 py-16 sm:px-6">
        <div className="mx-auto grid max-w-6xl gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {t("pub.partnerBenefits", { returnObjects: true }).map((b, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div key={b} data-testid={`partner-benefit-${i}`}
                className="rounded-2xl border border-border bg-card p-5">
                <Icon className="h-5 w-5 text-accent" />
                <p className="mt-3 text-sm font-bold">{b}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="px-4 pb-20 sm:px-6">
        <div className="mx-auto max-w-2xl"><PartnerForm /></div>
      </section>
    </div>
  );
}
